<!-- 新增或修改 -->
<template>
  <Dialog
    :title="title"
    :modelValue="modelValue"
    @onClosed="handleClosed"
    @onConfirm="handleAddUpdate"
  >
    <template #content>
      <el-form
        ref="dictFormRef"
        :model="dictFormData"
        :rules="rules"
        class="dict-form"
        label-width="80px"
      >
        <el-form-item prop="libraryName" label="字典名称">
          <el-input
            placeholder="请输入字典名称"
            v-model="dictFormData.libraryName"
          />
        </el-form-item>
        <el-form-item prop="libraryCode" label="字典编码">
          <el-input
            placeholder="请输入字典编码"
            v-model="dictFormData.libraryCode"
          />
        </el-form-item>
        <el-form-item label="字典描述">
          <el-input
            placeholder="请输入字典描述"
            v-model="dictFormData.libraryDesc"
          />
        </el-form-item>
      </el-form>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Element/Dialog";
import { isNull } from "@/utils/fangerUtils";
import { ref, watch, onMounted } from "vue";
import { addLibrary, updateLibrary } from "@/api/system/dict";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "新增",
  },
  data: {
    type: Object,
    default: () => ({}),
  },
});

const emits = defineEmits(["update:modelValue", "success"]);

const handleClosed = () => {
  emits("update:modelValue", false);
};

const dictFormData = ref({});
const dictFormRef = ref(null);

// 执行新增或修改
const handleAddUpdate = () => {
  dictFormRef.value.validate((valid) => {
    if (!valid) return;
    // 新增
    if (isNull(dictFormData.value?.libraryId)) {
      addLibrary(dictFormData.value)
        .then((res) => {
          handleClosed();
          emits("success", dictFormData.value);
        })
        .catch((res) => {});
    } else {
      // 修改
      updateLibrary(dictFormData.value)
        .then((res) => {
          handleClosed();
          emits("success", dictFormData.value);
        })
        .catch((res) => {});
    }
  });
};

onMounted(() => {
  watch(
    () => props.data,
    (newVal) => {
      if (isNull(newVal)) {
        dictFormData.value = {};
      } else {
        dictFormData.value = { ...newVal };
      }
    }
  );
});

const rules = {
  libraryCode: [
    {
      required: true,
      trigger: "blur",
      message: "字典编码为必填项",
    },
  ],
  libraryName: [
    {
      required: true,
      trigger: "blur",
      message: "字典名称为必填项",
    },
  ],
};
</script>

<style lang="scss" scoped></style>
